import { makeAutoObservable, runInAction } from 'mobx'
import api from 'core/api'
import { orderBy } from 'lodash'

export default class FeatureSwitches {
    featureSwitches = []
    fsDescriptions = {}
    globalFeatureSwitches = {}
    loading = true
    shouldFetchFS = true

    constructor() {
        makeAutoObservable(this)
        this.toggleGlobalFeatureSwitch = this.toggleGlobalFeatureSwitch.bind(this)
        this.toggleFeatureSwitch = this.toggleFeatureSwitch.bind(this)
    }

    fetchAllFeatureSwitches = async() => {
        this.loading = true
        try {
            const descriptionsPromise = api.admin.getFeatureSwitchesDescription()
            const globalPromise = api.admin.getFeatureSwitchesGlobal()
            const whiteLabelsPromise = api.admin.getWhiteLabelsList()

            const results = await Promise.all([descriptionsPromise, globalPromise, whiteLabelsPromise])

            runInAction(() => {
                this.fsDescriptions = results[0].result
                this.globalFeatureSwitches = results[1].result
                this.featureSwitches = orderBy(results[2].result, 'displayName', 'asc')
                this.loading = false
                this.shouldFetchFS = false
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false
            })
            console.error("Failed to fetch feature switches:", error)
        }
    }

    toggleGlobalFeatureSwitch(featureSwitch, value) {
        runInAction(() => {
            this.globalFeatureSwitches = {
                ...this.globalFeatureSwitches,
                [featureSwitch]: value
            }
        })
    }

    toggleFeatureSwitch({ whiteLabelUid, featureSwitch, value }) {
        runInAction(() => {
            const index = this.featureSwitches.findIndex(x => x.whiteLabelUid === whiteLabelUid)
            if (index !== -1) {
                const updatedFeatureSwitches = [...this.featureSwitches]
                updatedFeatureSwitches[index].featureSwitches[featureSwitch] = value
                this.featureSwitches = updatedFeatureSwitches
            }
        })
    }
}
